/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _matchesSelector = _interopRequireDefault(require("./matchesSelector"));
function selectParent(selector, node) {
  node = node.parentElement;
  while (node) {
    if ((0, _matchesSelector.default)(node, selector)) {
      return node;
    }
    node = node.parentElement;
  }
  return false;
}
var _default = selectParent;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/common/selectParent.js
// module id = 101
// module chunks = 0